<div>

    <app-custom-date-filter (dateSeletected)="setDateFilterPeriods($event)"></app-custom-date-filter>
    <div>
        <br>
        <app-summary-graphs [projects]="projects()" [timeTracks]="timeTracks()" [periodStart]="periodStart"
            [periodEnd]="periodEnd" />
    </div>
    <div>
        <app-summary-resume [projects]="projects()" [timeTracks]="timeTracks()" [users]="users()"
            [periodStart]="periodStart" [periodEnd]="periodEnd" />
    </div>
</div>
